import { render } from "./CoreDrillForm.vue?vue&type=template&id=5847bc3c"
import script from "./CoreDrillForm.vue?vue&type=script&lang=js"
export * from "./CoreDrillForm.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__